import { useState } from "react";
import {
  Button,
  PlusSvg,
  XSvg,
  CreditCardPaySvg,
  ReceiptRefundSvg,
} from "@components/index";

export const FooterMobile = () => {
  const [isShown, setIsShown] = useState(false);

  return (
    <div className="fixed bottom-16 right-4">
      <Button
        onlyIcon={!isShown ? <PlusSvg /> : <XSvg />}
        height="small"
        className="relative z-10 rounded-3xl bg-secondary-100"
        onClick={() => setIsShown(!isShown)}
        dataTestid="button_mobilePlus"
      />
      {isShown && (
        <div className="fixed bottom-0 left-0 right-0 top-0 bg-secondary-54">
          <div className="absolute bottom-32 left-2 right-2 flex justify-end rounded-2xl bg-white-100 p-2 after:absolute after:-bottom-2 after:right-5 after:block after:h-6 after:w-6 after:rotate-45 after:rounded-md after:bg-white-100">
            <div className="z-10 w-full">
              <div className="py-4 text-center text-300 font-bold text-black-100">
                Choose the Option You Need
              </div>
              <Button
                isLink
                leftIcon={<ReceiptRefundSvg />}
                title="Add Refund"
                href="/transactions/refund"
                variant="secondary"
                height="small"
                dataTestid="button_topNavAddRefund"
              />
              <Button
                isLink
                leftIcon={<CreditCardPaySvg />}
                title="Add Transaction"
                href="/transactions/create"
                height="small"
                className="mt-2"
                dataTestid="button_addTransaction"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
